module.exports = __webpack_public_path__ + "img/1.公司简介.3765654f.jpg";